<template>
  <h2 v-if="title" class="title heading-m">
    <span v-if="title">
      {{ title }}
    </span>
    <span v-if="goto" class="link-text">
      <ui-ui-link
        :responsive-ico="true"
        :path="goto.url"
        icon-after="right"
        class="link-text"
        font-class="body-m-regular"
        mode="link"
        :target="newTab ? `_blank` : '_self'"
        @click="sendPromo"
      >
        {{ !isMobile ? goto.title : 'Всё' }}
      </ui-ui-link>
    </span>

    <slot />
  </h2>
</template>

<script setup lang="ts">
import { useMediaQueryStore } from '~/stores/mediaQuery';

defineProps({
  title: String,
  goto: Object,
  newTab: {
    type: Boolean,
    default: false,
  },
});

const nuxtApp = useNuxtApp();
const mediaStore = useMediaQueryStore();
const isMobile = computed(
  () =>
    mediaStore.isMobile ||
    mediaStore.isLessEs ||
    mediaStore.isEs ||
    mediaStore.isSm ||
    mediaStore.isMd
);
const sendPromo = () => {
  nuxtApp.vueApp.$nuxt.$ymGoalEventPromo(
    'Promokody: click na knopku_vse promokody_na glavnoi',
    ''
  );
};
</script>
<style lang="scss" scoped src="./SectionHeaderScss.scss"></style>
